import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, method: String, saved: Boolean }

  async toggle(event) {
    event.preventDefault()
    console.log('Save task toggle clicked', event)
    console.log('Button element:', this.element)
    console.log('URL value:', this.urlValue)
    console.log('Method value:', this.methodValue)
    console.log('Saved value:', this.savedValue)
    
    // The controller is attached to the button element
    const button = this.element
    if (!button) {
      console.error('No button found')
      return
    }
    
    const icon = button.querySelector('i')
    
    // Show loading state
    button.disabled = true
    if (icon) {
      icon.className = 'bi bi-hourglass-split'
    }
    
    try {
      const formData = new FormData()
      if (this.methodValue === 'DELETE') {
        formData.append('_method', 'DELETE')
      }
      
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content || '',
          'Accept': 'application/json'
        },
        body: formData
      })
      
      if (response.ok) {
        const data = await response.json()
        this.updateUI(data.saved, data.saved_count)
      } else {
        console.error('Failed to save/unsave task')
        this.resetButton()
      }
    } catch (error) {
      console.error('Error:', error)
      this.resetButton()
    }
  }

  updateUI(isSaved, savedCount) {
    const button = this.element
    const icon = button.querySelector('i')
    
    // Update icon class
    if (icon) {
      icon.className = isSaved ? 'bi bi-bookmark-fill' : 'bi bi-bookmark'
    }
    
    // Update opacity
    if (isSaved) {
      button.classList.remove('opacity-50')
      button.classList.add('opacity-100')
    } else {
      button.classList.remove('opacity-100')
      button.classList.add('opacity-50')
    }
    
    // Update tooltip text
    if (button.getAttribute('data-bs-toggle') === 'tooltip') {
      button.setAttribute('title', isSaved ? 'Remove from saved tasks' : 'Save task for later')
      // Reinitialize tooltip with new text if Bootstrap tooltips are active
      if (window.bootstrap && button._tooltip) {
        button._tooltip.dispose()
        new bootstrap.Tooltip(button)
      }
    }
    
    button.disabled = false
    
    // Update data values for next toggle
    this.savedValue = isSaved
    if (isSaved) {
      this.urlValue = this.urlValue.replace('/save_task', '/unsave_task')
      this.methodValue = 'DELETE'
    } else {
      this.urlValue = this.urlValue.replace('/unsave_task', '/save_task')
      this.methodValue = 'POST'
    }
    
    // Update saved count badge if present
    const badge = document.querySelector('.badge.bg-secondary')
    if (badge && savedCount !== undefined) {
      badge.textContent = `${savedCount} saved`
    }
    
    // If we're on the saved tasks dashboard page and task was unsaved, remove the card
    if (!isSaved && window.location.pathname.includes('saved_tasks')) {
      const card = button.closest('.col-md-6, .col-lg-4, .mb-3')
      if (card) {
        card.remove()
        
        // Check if no more saved tasks and show empty state
        const remainingCards = document.querySelectorAll('.col-md-6 .card')
        if (remainingCards.length === 0) {
          location.reload() // Simple refresh to show empty state
        }
      }
    }
  }

  resetButton() {
    const button = this.element
    const icon = button.querySelector('i')
    
    button.disabled = false
    if (icon) {
      // Reset to original state
      icon.className = this.savedValue ? 'bi bi-bookmark-fill' : 'bi bi-bookmark'
    }
  }
}